import { Params } from '@angular/router';
import { DateFormatType } from '@shared/core';

export enum UITableColumnCellType {
  Text = 'text',
  Number = 'number',
  Date = 'date',
  Link = 'link',
}

export type ITableColumnCellConfigType =
  | ITableColumnTextCell
  | ITableColumnNumberCell
  | ITableColumnDateCell
  | ITableColumnLinkCell;

export interface ITableColumnCellConfig {
  type: UITableColumnCellType;
  fieldName: string;
  fieldValue?: unknown;
  formatter?: (rowData: unknown) => unknown;
}

export interface ITableColumnTextCell extends ITableColumnCellConfig {
  type: UITableColumnCellType.Text;
  isTranslatable?: boolean;
}

export interface ITableColumnDateCell extends ITableColumnCellConfig {
  type: UITableColumnCellType.Date;
  format?: DateFormatType;
}

export interface ITableColumnNumberCell extends ITableColumnCellConfig {
  type: UITableColumnCellType.Number;
}

export interface ITableColumnLinkCell extends ITableColumnCellConfig {
  type: UITableColumnCellType.Link;
  isTranslatable?: boolean; // fieldName value is translatable
  path?: string; // absolute routing path
  skipLocation?: boolean; // skipLocationChange  when navigating
  relativeTo?: boolean;
  isExternalLink?: boolean;
  queryParams?: Params;
}
